import type { FC } from 'react';

import { Tooltip } from '@/components/ui/tooltip';
import { cls } from '@/utils/cls';
import { WarrantyCoverageStatus } from '@/warranty/domain/entities/warranty-status';

import { WarrantyCoverageStatusIcon } from './WarrantyCoverageStatusIcon';

type WarrantyCoverageStatusBadgeProps = {
  status: WarrantyCoverageStatus;
};

const labelFromWarrantyCoverage: Record<WarrantyCoverageStatus, string> = {
  [WarrantyCoverageStatus.NO_DATA]: 'No Data',
  [WarrantyCoverageStatus.VALID]: 'Valid',
  [WarrantyCoverageStatus.EXPIRED]: 'Expired',
  [WarrantyCoverageStatus.CASE_OPEN]: 'Potential Case',
};

const styleFromWarrantyCoverage: Record<WarrantyCoverageStatus, string> = {
  [WarrantyCoverageStatus.NO_DATA]: 'bg-gray-50 text-gray-700',
  [WarrantyCoverageStatus.VALID]: 'bg-green-50 text-green-700',
  [WarrantyCoverageStatus.EXPIRED]: 'bg-red-50 text-red-700',
  [WarrantyCoverageStatus.CASE_OPEN]: 'bg-blue-50 text-blue-700',
};

export const WarrantyCoverageStatusBadge: FC<
  WarrantyCoverageStatusBadgeProps
> = ({ status }) => (
  <Tooltip delay content={labelFromWarrantyCoverage[status]}>
    <span
      className={cls(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium',
        styleFromWarrantyCoverage[status],
      )}
    >
      <WarrantyCoverageStatusIcon status={status} />
      {labelFromWarrantyCoverage[status]}
    </span>
  </Tooltip>
);
